// Port of api/fuel/app/classes/filter/package/games/game/package/user.php
export default {
	run: function(pkg, local, global) {
		pkg.user = {
			commented: global.userComments && global.userComments[local.game_id] !== undefined,
			comment: (global.userComments && global.userComments[local.game_id]) || '',
			plays: (local.plays && local.plays.user && local.plays.user.total) || 0,
			duration: (local.plays && local.plays.user && local.plays.user.duration) || 0,
			play_first: (local.plays && local.plays.user && local.plays.user.first) || 0,
			play_last: (local.plays && local.plays.user && local.plays.user.last) || 0,
			rating_avg: local.ratings && local.ratings.user !== null ? Math.round(local.ratings.user * 10) / 10 : '-',
			rating_band: local.ratings && local.ratings.user !== null ? Math.floor(local.ratings.user) : '-',
			version: local.versions ? local.versions.user : false,
			status: local.status ? local.status.user : {},
			parts: local.parts ? local.parts.user : [],
			wishlist: local.wishlist ? local.wishlist.user : []
		}
		return pkg
	}
}
